export default function PaymentHistoryIcon({
  width = 18,
  height = 15,
  color = "#8E8C8F",
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.50411 -0.000167847H16.5041C16.9644 -0.000167847 17.3375 0.372924 17.3375 0.833165V14.1665C17.3375 14.6268 16.9644 14.9998 16.5041 14.9998H1.50411C1.04388 14.9998 0.670776 14.6268 0.670776 14.1665V0.833165C0.670776 0.372924 1.04388 -0.000167847 1.50411 -0.000167847ZM15.6708 6.66651H2.33744V13.3332H15.6708V6.66651ZM15.6708 4.99983V1.6665H2.33744V4.99983H15.6708ZM10.6708 9.99984H14.0041V11.6665H10.6708V9.99984Z"
        fill={color}
      />
    </svg>
  );
}
